export default {
  default: () => import("/home/node/layouts/default.vue").then(m => m.default || m)
}